import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const logisticOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Inicio', to: '/' },
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Red logística', to: '/business/logistics-network' },
  {
    label: 'Operadores Logísticos',
    onClick: () => navigate('/business/logistic-operator'),
  },
];

export const logisticOperatorDashboardBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] => [
  ...logisticOperatorsPageBreadcrumbs(navigate),
  {
    label: operatorName || 'Operador Logístico',
    onClick: () =>
      navigate(`/business/logistic-operator/${operatorId}/dashboard`),
  },
];

export const logisticOperatorCommercesBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] => [
  ...logisticOperatorDashboardBreadcrumbs(navigate, operatorId, operatorName),
  {
    label: 'Comercios',
    onClick: () =>
      navigate(`/business/logistic-operator/${operatorId}/commerces`),
  },
];

export const createLogisticOperatorAssignmentBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] =>
  logisticOperatorDashboardBreadcrumbs(navigate, operatorId, operatorName);

export const editServiceWithOperatorBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  _serviceWithOperatorId: string,
  operatorName?: string,
  _serviceName?: string
): NavigateLink[] =>
  logisticOperatorDashboardBreadcrumbs(navigate, operatorId, operatorName);

export const logisticOperatorTimeSlotsBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] => [
  ...logisticOperatorDashboardBreadcrumbs(navigate, operatorId, operatorName),
  {
    label: 'Franjas horarias',
    onClick: () =>
      navigate(`/business/logistic-operator/${operatorId}/time-slots`),
  },
];

export const createTimeSlotBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] =>
  logisticOperatorTimeSlotsBreadcrumbs(navigate, operatorId, operatorName);

export const editTimeSlotBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  _timeSlotId: string,
  operatorName?: string
): NavigateLink[] =>
  logisticOperatorTimeSlotsBreadcrumbs(navigate, operatorId, operatorName);

export const logisticOperatorZonesBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] => [
  ...logisticOperatorDashboardBreadcrumbs(navigate, operatorId, operatorName),
  {
    label: 'Zonas',
    onClick: () => navigate(`/business/logistic-operator/${operatorId}/zones`),
  },
];

export const createZoneBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] =>
  logisticOperatorZonesBreadcrumbs(navigate, operatorId, operatorName);

export const viewZoneBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  _zoneId: string,
  operatorName?: string,
  _zoneName?: string
): NavigateLink[] =>
  logisticOperatorZonesBreadcrumbs(navigate, operatorId, operatorName);

export const editZoneBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  _zoneId: string,
  operatorName?: string,
  _zoneName?: string
): NavigateLink[] =>
  logisticOperatorZonesBreadcrumbs(navigate, operatorId, operatorName);

export const logisticOperatorServiceRulesConfigBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] => [
  ...logisticOperatorDashboardBreadcrumbs(navigate, operatorId, operatorName),
  {
    label: 'Reglas por servicio',
    onClick: () =>
      navigate(
        `/business/logistic-operator/${operatorId}/service-rules-config`
      ),
  },
];

export const editServiceRulesConfigBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  _serviceWithOperatorId: string,
  operatorName?: string,
  _serviceName?: string
): NavigateLink[] =>
  logisticOperatorServiceRulesConfigBreadcrumbs(
    navigate,
    operatorId,
    operatorName
  );

export const logisticOperatorTransitionsBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] => [
  ...logisticOperatorDashboardBreadcrumbs(navigate, operatorId, operatorName),
  {
    label: 'Transiciones',
    onClick: () =>
      navigate(`/business/logistic-operator/${operatorId}/transitions`),
  },
];

export const createTransitionBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  operatorName?: string
): NavigateLink[] =>
  logisticOperatorTransitionsBreadcrumbs(navigate, operatorId, operatorName);

export const editTransitionBreadcrumbs = (
  navigate: NavigateFunction,
  operatorId: string,
  _transitionId: string,
  operatorName?: string,
  _transitionName?: string
): NavigateLink[] =>
  logisticOperatorTransitionsBreadcrumbs(navigate, operatorId, operatorName);
